import axios from "axios";
import { server } from "../../server";

// Create product (admin)
export const createProduct = (formData) => async (dispatch) => {
  try {
    dispatch({ type: "productCreateRequest" });
    const config = { headers: { "Content-Type": "multipart/form-data" }, withCredentials: true };
    const { data } = await axios.post(server + "/product/create-product", formData, config);
    dispatch({ type: "productCreateSuccess", payload: data.product });
  } catch (error) {
    dispatch({ type: "productCreateFail", payload: error.response?.data?.message || error.message });
  }
};

// Update product (admin)
export const updateProduct = (id, formData) => async (dispatch) => {
  try {
    dispatch({ type: "updateProductRequest" });
    const config = { headers: { "Content-Type": "multipart/form-data" }, withCredentials: true };
    const { data } = await axios.put(server + "/product/update-product/" + id, formData, config);
    dispatch({ type: "updateProductSuccess", payload: data.product });
  } catch (error) {
    dispatch({ type: "updateProductFailed", payload: error.response?.data?.message || error.message });
  }
};

// Delete product (admin)
export const deleteProduct = (id) => async (dispatch) => {
  try {
    dispatch({ type: "deleteProductRequest" });
    const { data } = await axios.delete(server + "/product/delete-product/" + id, { withCredentials: true });
    dispatch({ type: "deleteProductSuccess", payload: { message: data.message, productId: id } });
  } catch (error) {
    dispatch({ type: "deleteProductFailed", payload: error.response?.data?.message || error.message });
  }
};

// Get all products (public)
export const getAllProducts = (params) => async (dispatch) => {
  try {
    dispatch({ type: "getAllProductsRequest" });
    let url = server + "/product/get-all-products";
    if (params) {
      const queryString = new URLSearchParams(params).toString();
      url += "?" + queryString;
    }
    const { data } = await axios.get(url);
    dispatch({
      type: "getAllProductsSuccess",
      payload: {
        products: data.products,
        totalCount: data.totalCount,
        totalPages: data.totalPages,
        currentPage: data.currentPage,
      },
    });
  } catch (error) {
    dispatch({ type: "getAllProductsFailed", payload: error.response?.data?.message || error.message });
  }
};

// Get admin products
export const getAdminProducts = (params) => async (dispatch) => {
  try {
    dispatch({ type: "getAdminProductsRequest" });
    let url = server + "/product/admin/all-products";
    if (params) {
      const queryString = new URLSearchParams(params).toString();
      url += "?" + queryString;
    }
    const { data } = await axios.get(url, { withCredentials: true });
    dispatch({
      type: "getAdminProductsSuccess",
      payload: {
        products: data.products,
        totalCount: data.totalCount,
        totalPages: data.totalPages,
      },
    });
  } catch (error) {
    dispatch({ type: "getAdminProductsFailed", payload: error.response?.data?.message || error.message });
  }
};

// Get single product
export const getSingleProduct = (idOrSlug) => async (dispatch) => {
  try {
    dispatch({ type: "getSingleProductRequest" });
    const { data } = await axios.get(server + "/product/get-product/" + idOrSlug);
    dispatch({ type: "getSingleProductSuccess", payload: data.product });
  } catch (error) {
    dispatch({ type: "getSingleProductFailed", payload: error.response?.data?.message || error.message });
  }
};

// Get featured products
export const getFeaturedProducts = () => async (dispatch) => {
  try {
    dispatch({ type: "getFeaturedRequest" });
    const { data } = await axios.get(server + "/product/featured");
    dispatch({ type: "getFeaturedSuccess", payload: data.products });
  } catch (error) {
    dispatch({ type: "getFeaturedFailed", payload: error.response?.data?.message || error.message });
  }
};

// Get best sellers
export const getBestSellers = () => async (dispatch) => {
  try {
    dispatch({ type: "getBestSellersRequest" });
    const { data } = await axios.get(server + "/product/best-sellers");
    dispatch({ type: "getBestSellersSuccess", payload: data.products });
  } catch (error) {
    dispatch({ type: "getBestSellersFailed", payload: error.response?.data?.message || error.message });
  }
};

export const clearSuccess = () => async (dispatch) => {
  dispatch({ type: "clearSuccess" });
};

// Get all products for a specific shop
export const getAllProductsShop = (id) => async (dispatch) => {
  try {
    dispatch({ type: "getAllProductsShopRequest" });
    const { data } = await axios.get(server + "/product/get-all-products-shop/" + id, { withCredentials: true });
    dispatch({
      type: "getAllProductsShopSuccess",
      payload: data.products,
    });
  } catch (error) {
    dispatch({ type: "getAllProductsShopFailed", payload: error.response?.data?.message || error.message });
  }
};
